module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "toc"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_tit"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TITLE PAGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_notice"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COPYRIGHT NOTICE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot",
    attrs: {
      "id": "c_ep"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/epigraph#ep"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EPIGRAPHS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_intro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("INTRODUCTION: WHO IS TIPTREE, WHAT IS HE?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("1. THE INNOCENT ADVENTURESS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("2. AFRICA (1921–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("3. CHILDHOOD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("4. CANNIBALS AT HOME (1924–25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("5. CELEBRITY (1925–28)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("6. GIRLS’ SCHOOL (1929–30)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("7. LIKE A DU MAURIER HEROINE (1931)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("8. AMBITION (1931–33)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("9. “WE HAVE FOUND IT QUITE IMPOSSIBLE TO PERSUADE HER TO LEAD A NORMAL LIFE” (1933–34)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("10. LOVE TROUBLE (1935–36)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("11. SEX AND ARGUING (1936–40)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("12. WAR FEVER (1941–42)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("13. FORT DES MOINES (1942–43)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("14. IN A PENTAGON BASEMENT (1944)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("15. TING (1945)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("16. GOING UNDERGROUND (1946–47)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("17. RUNNING A CHICKEN HATCHERY IN NEW JERSEY (1948–52)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("18. THE AGENCY (1952–55)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("19. A DISAPPEARANCE AND A RETURN (1955)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("20. LEARNING TO SEE (1956–59)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("21. CHEZ WOMEN (1950S)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("22. PREDOCTORAL RESEARCH GRANT NO. 10,907 (1960–62)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("23. RAT SCIENCE (1963–67)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("24. THE BIRTH OF A WRITER (1967)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("25. DR. JEKYLL AND MR. SPOCK (1968)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("26. FIRST CONTACT (1969)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("27. THE YUCATÁN (1970)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("28. A DECADENT INTELLECTUAL FAKED UP IN A WOODMAN’S SHIRT (1971)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("29. FRIENDSHIPS (1971–73)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("30. THE WOMEN MEN DON’T SEE (1972)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("31. A GLASS GETTING READY TO CRACK (1973)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("32. “HOUSTON, HOUSTON, DO YOU READ?” (1973–74)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("33. A TIN ROCKET (1974)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("34. A SENSITIVE MAN (1974–75)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("35. DEPRESSION (1975–76)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("36. MARY’S DEATH (1976)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("37. TIPTREE REVEALED (1976)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("38. “I LIVE IN MY BODY AS IN AN ALIEN ARTIFACT” (1977)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("39. WRITING AGAIN (1979–81)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot",
    attrs: {
      "id": "c_ch40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("40. LOVE IS THE PLAN THE PLAN IS DEATH (1982–87)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_sou"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/sou#sou",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NOTE ON SOURCES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_work"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/work#work",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("WORKS BY ALICE B. SHELDON")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_note"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("INDEX")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_aut"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/aut#aut",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ABOUT THE AUTHOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_crt"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#crt",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COPYRIGHT")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0